/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
  fill?: string,
}>;

const SettingsMoreIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={props.fill || "none"} strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.254,13.5 L23.5,13.5 L23.5,10.5 L20.253,10.5 C20.044,9.633 19.702,8.319 19.25,7.578 L21.546,5.283 L18.717,2.454 L16.42,4.75 C15.68,4.298 14.367,3.957 13.5,3.748 L13.5,0.5 L10.5,0.5 L10.5,3.748 C9.633,3.957 8.319,4.298 7.579,4.75 L5.282,2.454 L2.453,5.283 L4.75,7.579 C4.298,8.319 3.956,9.633 3.746,10.5 L0.5,10.5 L0.5,13.5 L3.746,13.5 C3.956,14.367 4.298,15.681 4.75,16.421 L2.453,18.718 L5.282,21.546 L7.578,19.249 C8.319,19.703 9.633,20.044 10.5,20.254 L10.5,23.5 L13.5,23.5 L13.5,20.254 C14.367,20.044 15.681,19.702 16.42,19.25 L18.718,21.546 L21.546,18.718 L19.25,16.421 C19.702,15.681 20.044,14.367 20.254,13.5 Z" />
      <circle cx="12" cy="12" r="4.5" />
    </g>
  </svg>
);

export default SettingsMoreIcon;
